<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form ref="methodForm" @submit.prevent="handleSubmit(save)" @reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="px-lg-2" style="width: 60% !important;">
            <div class="card">
              <div class="card-body">
                <div>
                  <b-row>
                    <label v-if="mode == 'add' && !modesOfPaymentModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a Mode of Payment for Module.</label>
                    <label v-else-if="mode == 'edit' && !modesOfPaymentModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Mode of Payment for Module.</label>
                  </b-row>

                  <b-row>
                    <div class="d-flex align-items-center mb-4">
                      <label class="form-label small fw-bold me-2 mb-0"
                        >Active</label
                      >
                      <toggle-button
                        class="m-0 me-2"
                        v-model="mopModuleStatus"
                        color="#e73092"
                        :sync="true"
                      />
                    </div>
                  </b-row>
                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Mode of Payment<span class="text-danger">*</span></label
                      >
                      <validation-provider
                        name="modeOfPayment"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          :multiple="false"
                          v-model="selectedMop"
                          :options="mopOptions"
                          track-by="value"
                          label="text"
                          name="modeOfPayment"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select mode of payment"
                          :allow-empty="false"
                          :preselect-first="false"
                          :hide-selected="false"
                          :close-on-select="true"
                          :class="{
                            invalid: errors[0],
                          }"
                          :disabled="methodId>0"
                        >
                        </multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>


                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Module<span class="text-danger">*</span></label
                      >
                      <validation-provider
                        name="module"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          :multiple="false"
                          v-model="selectedModule"
                          :options="moduleOptions"
                          track-by="value"
                          label="text"
                          name="module"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select module"
                          :allow-empty="false"
                          :preselect-first="false"
                          :hide-selected="false"
                          :close-on-select="true"
                          :class="{
                            invalid: errors[0],
                          }"
                          :disabled="methodId>0"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Min Amount Required</label
                      >
                      <div class="input-group">
                        <div class="input-group-text">₱</div>
                        <b-form-input
                          :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                          type="text"
                          class="form-control"
                          v-model="minAmountRequired"
                          placeholder="0"
                        />
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Rate Type<span class="text-danger">*</span></label
                      >
                      <validation-provider
                        name="rateType"
                        rules="required"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <multiselect
                          :multiple="false"
                          v-model="selectedRateType"
                          :options="rateTypeOptions"
                          track-by="value"
                          label="text"
                          name="rateType"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select MDR or Rebate Percentage"
                          :allow-empty="false"
                          :preselect-first="false"
                          :hide-selected="false"
                          :close-on-select="true"
                          :class="{
                            invalid: errors[0],
                          }"
                          :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                        ></multiselect>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  
                  <b-row v-if="mopModuleItem.rateType == 'mdr'">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Percentage Charged to User</label
                      >
                      <validation-provider
                        name="MDR"
                        :rules="{required:true,min_value:0}"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <div class="input-group"
                          :class="{
                            invalid: errors[0]
                          }">
                          <div class="input-group-text">%</div>
                          <b-form-input
                            type="number"
                            class="form-control"
                            v-model="mdrPercentage"
                            placeholder="0.00"
                            :class="{
                              invalid: errors[0]
                            }"
                          :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                          />
                        </div>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row v-if="mopModuleItem.rateType == 'rebate'">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Additional Rebate Percentage</label
                      >
                      <validation-provider
                        name="Rebate"
                        :rules="{required:true,min_value:0}"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <div class="input-group"
                          :class="{
                            invalid: errors[0]
                          }">
                          <div class="input-group-text">%</div>
                          <b-form-input
                            type="number"
                            class="form-control"
                            v-model="rebatePercentage"
                            placeholder="0.00"
                            :class="{
                              invalid: errors[0]
                            }"
                            :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                          />
                        </div>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12" class="mb-1">
                      <label class="form-label small fw-bold me-2"
                        >Set Max Charge</label
                      >
                      <toggle-button
                        class="m-0 me-2"
                        v-model="mopModuleHaveCapped"
                        color="#e73092"
                        :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                        :sync="true"
                      />
                    </b-col>
                    <b-col sm="12" class="mb-3">
                    </b-col>
                  </b-row>
                  <b-row v-if="mopModuleItem.haveCapped == 1">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Capped Amount</label
                      >
                      <validation-provider
                        name="Capped Amount"
                        :rules="{required:true,min_value:0}"
                        v-slot="{ errors, ariaMsg }"
                      >
                        <div class="input-group"
                          :class="{
                            invalid: errors[0]
                          }">
                          <div class="input-group-text">₱</div>
                          <b-form-input
                            type="number"
                            class="form-control"
                            v-model="cappedAmount"
                            placeholder="0.00"
                            :class="{
                              invalid: errors[0]
                            }"
                            :disabled="mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule"
                          />
                        </div>
                        <b-form-invalid-feedback v-bind="ariaMsg">
                          {{ errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>

                  <b-row>
                    <div class="d-flex align-items-center mb-3">
                      <label class="form-label small fw-bold mb-0 me-2"
                        >Schedule Inactive</label
                      >
                      <toggle-button
                        class="m-0 me-2"
                        v-model="inactiveSchedule.status"
                        @input="
                          inactiveSchedule.start=''; 
                          inactiveSchedule.end=''; 
                          resetSchedule()"
                        color="#e73092"
                        :sync="true"
                      />
                    </div>
                    
                    <div class="mb-3" v-if="inactiveSchedule.status">
                      <b-row class="me-0 pe-0 mb-1">
                        <b-col sm="12" lg="6" class="pe-0">
                          <label class="form-label small fw-bold mb-0 me-2"
                            >Start Date & Time<span class="text-danger">*</span></label
                          >
                          <flat-pickr
                            :disabled="!inactiveSchedule.status"
                            v-model="inactiveSchedule.start"
                            :config="rangeOptions"
                            placeholder="Select Start Date"
                            class="form-control w-100"
                            :class = "{
                              'is-invalid': !scheduleValidation.isStartDateValid,
                              'pe-none': !inactiveSchedule.status
                            }"
                            @input="resetSchedule()"
                          ></flat-pickr>
                        </b-col>
                        <b-col sm="12" lg="6" class="pe-0">
                          <label class="form-label small fw-bold mb-0 me-2"
                            >End Date & Time<span class="text-danger">*</span></label
                          >
                          <flat-pickr
                            :disabled="!inactiveSchedule.status"
                            v-model="inactiveSchedule.end"
                            :config="rangeOptions"
                            placeholder="Select End Date"
                            class="form-control w-100"
                            :class = "{
                              'is-invalid': !scheduleValidation.isEndDateValid,
                              'pe-none': !inactiveSchedule.status
                            }"
                            @input="resetSchedule()"
                          ></flat-pickr>
                        </b-col>
                      </b-row>
                      <div v-if="scheduleValidation.error" class="text-danger mt-2">
                        {{ scheduleValidation.error }}
                      </div>
                    </div>
                  </b-row>

                  <div v-if="mode == 'edit'" class="mt-2 mb-3 d-flex align-items-center">
                    <span class="flex-grow-1">
                      <b class="me-2">Change Log:</b>
                      <b-link @click="viewChangeLogModal">View</b-link>
                    </span>
                  </div>

                  <b-row v-if="mode == 'edit' && mopModuleItem.status != currentMopModuleItem.status">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Reason</label
                      >
                        <multiselect
                          :multiple="false"
                          v-model="mopModuleItem.reason"
                          :options="mopReason"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select reason"
                          :allow-empty="false"
                          :preselect-first="true"
                          :hide-selected="false"
                          :close-on-select="true"
                        ></multiselect>
                    </b-col>
                  </b-row>

                  <b-row v-if="false">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Success Redirect URL</label
                      >
                        <b-form-input
                          type="text"
                          class="form-control"
                          v-model="mopModuleItem.successRedirect"
                          placeholder="Enter success URL"
                        />
                    </b-col>
                  </b-row>

                  <b-row v-if="false">
                    <b-col sm="12" class="mb-3">
                      <label class="form-label small fw-bold"
                        >Fail Redirect URL</label
                      >
                        <b-form-input
                          type="text"
                          class="form-control"
                          v-model="mopModuleItem.failRedirect"
                          placeholder="Enter fail URL"
                        />
                    </b-col>
                  </b-row>

                  <b-row v-if="mode == 'edit'">
                    <b-col sm="12" class="mb-3">
                      <mop-scheduler/>
                    </b-col>
                  </b-row>

                  <b-row class="mb-3">
                    <b-col
                      ><b-btn class="w-100" type="submit" variant="primary" :disabled="(mode == 'add' ? !modesOfPaymentModule.access.create : !modesOfPaymentModule.access.update) || (mopModuleItem.hasOngoingCampaign || mopModuleItem.hasOngoingSchedule)"
                        >{{ mode == 'edit' ? 'Update': 'Save' }}</b-btn
                      ></b-col
                    >
                    <b-col v-show="false"
                      ><b-btn ref="formReset" class="w-100" type="reset" variant="primary"
                        >Reset</b-btn
                      ></b-col
                    >
                    <b-col
                      ><b-btn class="w-100 btn btn-light" @click="goToList"
                        >Cancel</b-btn
                      ></b-col
                    >
                  </b-row>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <b-modal
      id="changeLog"
      size="lg"
      centered
      hide-header-close
      v-model="changeLogModal"
      modal-class="change-log-modal"
    >
      <template #modal-title>
        Module Logs
      </template>
      <template #modal-footer>
        <div class="w-100 text-end">
          <b-button variant="light" class="px-5" @click="changeLogModal = false">Close</b-button>
        </div>
      </template>
      <div class="row align-items-start g-0 mt-2 mb-3">
        <div class="col-sm-2">
          <b-form-group label-for="search-type" class="text-end">
            <b-form-select
              v-model="searchValue.searchField"
              class="form-select rounded-0 shadow-none w-100"
              :options="searchLogOption"
            >
            </b-form-select>
          </b-form-group>
        </div>

        <div class="col-sm-3">
          <b-form-group label-for="search-keyword" description="Search Keyword" class="text-end">
            <input
              class="form-control rounded-0 shadow-none w-100"
              v-model="searchValue.search"
              placeholder="Search Keyword"
              @keydown.enter.prevent="fetchMopLogs"
            />
          </b-form-group>
        </div>

        <div class="col-sm-3 ms-3">
          <b-form-group label-for="date-range" description="Filter by date" class="text-end">
            <flat-pickr
              v-model="searchValue.dateRange"
              :config="logRangeOptions"
              placeholder="Select date range"
              class="form-control rounded-0 shadow-none w-100"
            ></flat-pickr>
          </b-form-group>
        </div>

        <div class="col d-flex justify-content-end align-items-center buttons-group gap-1 flex-wrap">
          <b-button variant="primary" type="button" @click="fetchMopLogs" class="px-3 d-flex align-items-center">
            <i class='bx bx-search bx-fw me-2'></i>
            Search
          </b-button>

          <b-button variant="primary" @click="onExport" type="button" class="px-3 d-flex align-items-center">
            <i class='uil uil-export me-2'></i>
            Export
          </b-button>
        </div>
      </div>
      <div class="row">
          <div class="col-sm-12">
            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="mopLogs"
                  :fields="logFields"
                  responsive="sm"
                  :current-page="searchValue.page"
                  :sort-by.sync="sortBy"
                  :no-local-sorting="true"
                  :sort-desc.sync="sortDesc"
                  @sort-changed="tableSorting"
                >
                  <template #cell(details)="data">
                    <a v-if="data.item.hasChange" href="#" class="view-link" @click.prevent="openChangePreview(data.item, $event)">View changes</a>
                  </template>
                  <template #cell(created_at)="data">
                    <span>{{ data.item.created_at | customFormatDate }}</span>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- change preview floating panel -->
            <div v-if="changePreviewVisible" class="change-preview">
              <div class="change-preview__inner">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <h6 class="mb-0 text-white fw-bold">Edited Fields:</h6>
                  <button class="btn-close" @click="closeChangePreview">×</button>
                </div>
                <!-- show changePreviewData.changes array as Before/After rows -->
                <div v-if="changePreviewData && changePreviewData.changes && changePreviewData.changes.length > 0">
                  <table class="table table-sm table-change mb-0">
                    <thead>
                      <tr>
                        <th style="width: 35%">Field</th>
                        <th style="width: 65%">Change</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(c, idx) in changePreviewData.changes" :key="idx">
                        <!-- <td>{{ c.field }}</td>
                        <td>{{ c.old }} → {{ c.new }}</td> -->
                        <td class="align-top text-white">{{ c.field }}</td>
                        <td>
                          <div class="before-line text-white">
                            <!-- <strong>Before:</strong> -->
                              Before:
                            <span class="ms-1">{{ Array.isArray(c.old) ? c.old.join(', ') : (c.old === null || c.old === undefined ? '-' : c.old) }}</span>
                          </div>
                          <div class="after-line text-white mt-2">
                            <!-- <strong>After:</strong> -->
                              After:
                            <span class="ms-1">{{ Array.isArray(c.new) ? c.new.join(', ') : (c.new === null || c.new === undefined ? '-' : c.new) }}</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="text-white text-center py-3">
                  <p class="mb-0">No detailed changes available.</p>
                </div>
              </div>
            </div>

            
            <div class="row g-0 text-center" v-if="mopLogsTotal == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 align-items-center" v-if="mopLogsTotal > 0">
              <div class="col-auto">
                <div class="d-flex align-items-center">
                  <label class="me-2 mb-0 col-form-label">Display</label>
                  <b-form-select v-model="searchValue.rows" :options="pageOptions" class="form-select shadow-none w-fit" @change="fetchMopLogs"></b-form-select>
                </div>
              </div>
              <div class="col" v-if="mopLogsTotal > searchValue.rows">
                <div class="float-end">
                  <b-pagination
                    class="pagination-rounded mb-0"
                    v-model="searchValue.page"
                    @input="fetchMopLogs"
                    :total-rows="mopLogsTotal"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div><!--end of col-12-->
      </div><!--end of row-->
    </b-modal>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import Multiselect from "vue-multiselect";
import mopScheduler from "@/views/pages/mode-of-payment/scheduler/index.vue";
import {
  layoutMethods,
  mopMethods,
  mopComputed
} from "@/state/helpers";
import Swal from "sweetalert2";
import _ from "lodash";
import { getModuleAccess } from '@/router/helper.js';
import moment from 'moment-timezone';

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  props: ["methodId","mode"],
  data(){
    return {
      logRangeOptions: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        wrap: false
      },
      mopList: [],
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      changePreviewData: null,
      changePreviewVisible: false,
      sortBy: 'createdAt',
      sortDesc: true,
      logFields: [
        { key: 'created_at', label: 'Date & Time', sortable: true },
        { key: 'activity', label: 'Activity', sortable: true },
        { key: 'details', label: 'Details', sortable: false },
        { key: 'created_by', label: 'Created By', sortable: true }
      ],
      searchLogOption: [
        { text: "Search All", value: null },
        { text: "Created By", value: 'createdBy' },
      ],
      searchValue: {
        search: null,
        searchField: null,
        dateRange: null,
        page: 1,
        rows: 10
      },
      changeLogModal:false,
      unlockReason: [
        "Completed Maintenance",
        "Resolved Bugs/Issue",
        "Resolved Fraud Investigation",
      ],
      lockReason: [
        "Maintenance",
        "Bugs/Issue",
        "Change in Business Strategy",
        "Fraud Investigation"
      ],
      currentMopModuleItem: {},
      mopModuleItem: {
        "mopId": null,
        "module": null,
        "minAmountRequired": null,
        "mdrPercentage": 0,
        "rebatePercentage": 0,
        "status": "a",
        "successRedirect": null,
        "failRedirect": null,
        "rateType":null,
        "haveCapped": 0,
        "cappedAmount": 0
      },
      modesOfPaymentModule: {
				access: {
					create: false,
          read: false,
          update: false,
          delete: false
				}
			},
      rateTypeOptions:[
        {text: 'MDR', value: 'mdr'},
        {text: 'Rate Percentage', value: 'rebate'}
      ],
      inactiveSchedule: {
        status: false,
        start: "",
        end: "",
      },
      rangeOptions: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
      },
      scheduleValidation: {
        isStartDateValid: true,
        isEndDateValid: true,
        error: null
      }
    }
  },
  computed: {
    ...mopComputed,
    minAmountRequired: {
      get(){
        return this.mopModuleItem.hasOngoingCampaign || this.mopModuleItem.hasOngoingSchedule ? this.mopModuleItem.mopScheduler[0]?.min_amount_required : this.mopModuleItem.minAmountRequired;
      },
      set(value){
        this.mopModuleItem.minAmountRequired = value;
      }
    },
    mdrPercentage: {
      get(){
        return this.mopModuleItem.hasOngoingCampaign || this.mopModuleItem.hasOngoingSchedule ? this.mopModuleItem.mopScheduler[0]?.mdr_percentage : this.mopModuleItem.mdrPercentage;
      },
      set(value){
        this.mopModuleItem.mdrPercentage = value;
      }
    },
    rebatePercentage: {
      get(){
        return this.mopModuleItem.hasOngoingCampaign || this.mopModuleItem.hasOngoingSchedule ? this.mopModuleItem.mopScheduler[0]?.rebate_percentage : this.mopModuleItem.rebatePercentage;
      },
      set(value){
        this.mopModuleItem.rebatePercentage = value;
      }
    },
    cappedAmount: {
      get(){
        return this.mopModuleItem.hasOngoingCampaign || this.mopModuleItem.hasOngoingSchedule ? this.mopModuleItem.mopScheduler[0]?.capped_amount : this.mopModuleItem.cappedAmount;
      },
      set(value){
        this.mopModuleItem.cappedAmount = value;
      }
    },
    mopModuleHaveCapped: {
      get(){
        var haveCapped = this.mopModuleItem.hasOngoingCampaign || this.mopModuleItem.hasOngoingSchedule ? this.mopModuleItem.mopScheduler[0]?.have_capped : this.mopModuleItem.haveCapped;
        if(haveCapped == 1){
          return true;
        } else {
          return false;
        }
      },
      set(value){
        if(value){
          this.mopModuleItem.haveCapped = 1;
        } else {
          this.mopModuleItem.haveCapped = 0;
        }
      }
    },
    mopLogs() {
      return (this.mopLoglist || []).map(log => {
        console.log(log);
        var hasChange = false;
        var changes = [];
        var newDetails = log.newDetails;
        var oldDetails = log.oldDetails;

        if(newDetails && oldDetails){
          // Check change fields
          for (const [key, value] of Object.entries(newDetails)) {
            var oldValue = oldDetails[key];
            var newValue = value;

            oldValue = oldValue == '0000-00-00 00:00:00' ? '' : oldValue;

            if(oldValue && newValue != oldValue){
              hasChange = true
              changes.push({
                field: this.camelToSentence(key),
                old: oldDetails[key],
                new: newDetails[key]
              })
            }
          }
        }
        
        return {
          id: log.id,
          created_at: log.created_at,
          activity: log.remarks || 'Update MOP details',
          created_by: log.actor || 'Unknown',
          hasChange: hasChange,
          changes: changes
        };
      });
    },

    mopLogsTotal() {
      return this.mopLogPageInfo?.total || 0;
    },
    mopReason: {
      get(){
        if(this.mopModuleItem.status == 'a'){
          return this.unlockReason;
        } else {
          return this.lockReason;
        }
      }
    },
    mopOptions: {
      get(){
        return this.mops.map(m => Object.assign({text: m.name, value: m.mopId}));
      }
    },
    moduleOptions: {
      get(){
        return this.modules.map(m => Object.assign({text: m.displayName, value: m.name}));
      }
    },
    mopModuleStatus: {
      get(){
        if(this.mopModuleItem.status == 'a'){
          return true;
        } else {
          return false;
        }
      },
      set(value){
        if(value){
          this.mopModuleItem.status = 'a';
        } else {
          this.mopModuleItem.status = 'i';
        }
      }
    },
    selectedModule: {
      get() {
        var selectedModule = null;
        this.moduleOptions.forEach((e) => {
          if (e.value == this.mopModuleItem.module) {
            selectedModule = e;
          }
        });
        return selectedModule;
      },
      set(selectedModule) {
        if (selectedModule) {
          this.mopModuleItem.module = selectedModule.value;
        } else {
          this.mopModuleItem.module = null;
        }
      },
    },
    selectedRateType: {
      get() {//mopModuleItem.rateType
        var selectedRateType = null;


        this.rateTypeOptions.forEach((e) => {
          if (e.value == this.mopModuleItem.rateType) {
            selectedRateType = e;
          }
        });

        selectedRateType = this.mopModuleItem.hasOngoingCampaign ? this.mopModuleItem.mopScheduler[0]?.rate_type : selectedRateType;

        return selectedRateType;
      },
      set(selectedRateType) {
        if (selectedRateType) {
          this.mopModuleItem.rateType = selectedRateType.value;
        } else {
          this.mopModuleItem.rateType = null;
        }
      },
    },
    selectedMop: {
      get() {
        var selectedMop = null;
        this.mopOptions.forEach((e) => {
          if (e.value == this.mopModuleItem.mopId) {
            selectedMop = e;
          }
        });
        return selectedMop;
      },
      set(selectedMop) {
        if (selectedMop) {
          this.mopModuleItem.mopId = selectedMop.value;
        } else {
          this.mopModuleItem.mopId = null;
        }
      }
    },
    scheduleStatus: {
      get (){
        try {
          const currDate = moment().utc(),
                startDate = moment(this.mopDetailsForm.mopScheduler[0]?.start_at??null).utc();

          let r = {message:"Waiting",color:"text-disabled"},
            endDate = this.mopDetailsForm.mopScheduler[0]?.end_at??null;
          if(endDate !=null){
            endDate = moment(this.mopDetailsForm.mopScheduler[0].end_at).utc();
          }

          if(currDate.isBetween(startDate, endDate) || currDate.isAfter(startDate)){
            r = {message:"Ongoing",color:"text-warning"}
          }
          if(currDate.isAfter(endDate)){
            r = {message:"Done",color:"text-success"}
          }
          // console.log(
          //   ":: scheduleStatus ::",
          //   currDate.format("YYYY-MM-DD HH:mm:ss"),
          //   startDate.format("YYYY-MM-DD HH:mm:ss"),
          //   endDate.format("YYYY-MM-DD HH:mm:ss")
          // );
          return r;
        } catch (error) {
          console.log("ERROR scheduleStatus:",error);
          return {message:"Waiting",color:"text-disabled"}
        }
      }
    },
    ongoingSchedule: {
      get (){
        try {
          if(this.scheduleStatus?.message == "Ongoing"){
            return true;
          }else{
            return false;
          }
        } catch (error) {
          return false;
        }
      }
    }
  },
  components: {
    Multiselect,
    ToggleButton,
    mopScheduler,
    flatPickr
  },
  methods: {
    ...layoutMethods,
    ...mopMethods,
    camelToSentence(camelCaseString){
      const spacedString = camelCaseString.replace(/([A-Z])/g, ' $1');
      const sentenceCaseString = spacedString.charAt(0).toUpperCase() + spacedString.slice(1).toLowerCase();
      
      return sentenceCaseString.trim();
    },
    openChangePreview(item) {
      if (this._changePreviewOutsideHandler) {
        document.removeEventListener('click', this._changePreviewOutsideHandler);
        this._changePreviewOutsideHandler = null;
      }

      // Store data and show preview
      this.changePreviewData = item || null;
      this.changePreviewVisible = true;

      // Setup click-outside handler with proper timing
      this.$nextTick(() => {
        setTimeout(() => {
          this._changePreviewOutsideHandler = (e) => {
            const panel = document.querySelector('.change-preview__inner');
            if (!panel || !this.changePreviewVisible) return;
            
            // Check if click is outside the panel
            if (!panel.contains(e.target)) {
              this.closeChangePreview();
            }
          };
          document.addEventListener('click', this._changePreviewOutsideHandler, true);
        }, 100);
      });
    },
    closeChangePreview() {
      this.changePreviewVisible = false;
      this.changePreviewData = null;
      
      // Remove click-outside listener
      if (this._changePreviewOutsideHandler) {
        document.removeEventListener('click', this._changePreviewOutsideHandler, true);
        this._changePreviewOutsideHandler = null;
      }
    },
    async viewChangeLogModal(){
        this.changeLogModal = true;
        await this.fetchMopLogs();
    },
    goBack() {
      this.$router.go(-1);
    },
    async fetchMopLogs() {

      const params = {
        module: 'MOP_MODULE',
        reference_record_id: this.methodId,
        page: this.searchValue.page,
        rows: this.searchValue.rows,
        sort: this.sortBy || 'createdAt',
        orderDesc: this.sortDesc
      };

      if (this.searchValue.search && this.searchValue.search.trim()) {
        params.search = this.searchValue.search.trim();
        params.searchField = this.searchValue.searchField || null;
      }

      // Add date range if present
      if (this.searchValue.dateRange) {
        params.dateRange = this.searchValue.dateRange;
      }

      // console.log('Fetching SKU logs with params:', params);

      try {
        await this.getMopLogList(params);
        // console.log('SKU logs loaded successfully:', response);
      } catch (error) {
        console.error('Error loading SKU logs:', error);
        this.$alertify?.error?.('Failed to load SKU logs');
      }
    },
    tableSorting(ctx) {
      // Update sort state
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      // console.log('Sorting by:', ctx.sortBy, 'desc:', ctx.sortDesc);
      // Refetch with new sort
      this.fetchMopLogs();
    },
    async onExport(){
      try{
        // ensure logs are up-to-date
        this.searchValue.page = 1;
        await this.fetchMopLogs();

        const total = this.mopLogsTotal || 0;
        if(total === 0){
          Swal.fire("Failed!", "No data available to export.", "warning");
          return;
        }

        const params = {
          email: JSON.parse(localStorage.getItem('userData')).email,
          module: 'MOP_MODULE',
          reference_record_id: this.methodId,
          page: this.searchValue.page,
          rows: this.searchValue.rows,
          sort: this.sortBy,
          orderDesc: this.sortDesc,
          search: this.searchValue.search,
          searchField: this.searchValue.searchField,
          dateRange: this.searchValue.dateRange,
        };

        await this.exportMopLogList(params);

        Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success");
      }catch(error){
        console.error('Export failed', error);
        Swal.fire("Failed!", `Your request for reports has failed.`, "warning");
      }
    },
    saveMode() {
      var mopObj = { 
        ...this.mopModuleItem,
        inactiveSchedStatus: this.inactiveSchedule.status,
        inactiveSchedStart: this.inactiveSchedule.status ? moment(this.inactiveSchedule.start).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        inactiveSchedEnd: this.inactiveSchedule.status ? moment(this.inactiveSchedule.end).utc().format("YYYY-MM-DD HH:mm:ss") : null
      };
      this.update(mopObj);
    },
    createMode() {
      var mopObj = { 
        ...this.mopModuleItem,
        inactiveSchedStatus: this.inactiveSchedule.status,
        inactiveSchedStart: moment(this.inactiveSchedule.start).utc().format("YYYY-MM-DD HH:mm:ss"),
        inactiveSchedEnd: moment(this.inactiveSchedule.end).utc().format("YYYY-MM-DD HH:mm:ss")
      };
      delete mopObj.id;
      this.create(mopObj);
    },
    async save() {
      // if(this.ongoingSchedule){
      //     Swal.fire({
      //       title: "MOP Update Failed!",
      //       text: `Unabled to update due to ongoing MOP schedule.`,
      //       icon: "warning",
      //       showCancelButton: false,
      //       confirmButtonColor: "#804997",
      //     });
      //   return false;
      // }

      // Validate inactive schedule
      await this.validateSchedule();

      if (!this.scheduleValidation.isStartDateValid || !this.scheduleValidation.isEndDateValid) {
        console.log("Invalid inactive schedule");
        return
      }

      if (parseInt(this.methodId)) {
        this.saveMode();
      } else {
        this.createMode();
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    create(mopObj) {
      delete mopObj.reason;

      this.createMopModule(mopObj)
        .then(() => {
          this.clearForm();

          var mopName = '';
          this.mopList.forEach(ml => {
            console.log(ml);

            if(ml.mopId == mopObj.mopId){
              mopName = ml.displayName;
            }
          });

          Swal.fire({
            title: "Module Created!",
            text: `${mopName} module has been successfully created.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#804997",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.goToList();
            }
          });
        })
        .catch((err) => {
          // console.log("Product template form err:",err);
          Swal.fire(
            "Create Failed!",
            err.message ? err.message : `${mopObj.productName} was not created.`,
            "error"
          );
        });
    },
    update(mopObj) {
      var updatedItem = {
        ...mopObj
      };

      var hasChanges = !_.isEqual(updatedItem, this.currentMopModuleItem);
      if(!hasChanges){
        Swal.fire({
          text: "No changes made",
          icon: "info",
          showCancelButton: true,
          cancelButtonText: "OK",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Back to Mode of Payment List",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      } else {
        if(this.mopModuleItem.status == this.currentMopModuleItem.status){
          delete updatedItem.reason;
        }

        this.updateMopModule(updatedItem)
          .then(() => {
            this.redirectForm = false;
            Swal.fire({
              title: "Update Successful!",
              text: `Module has been updated.`,
              icon: "success",
              showCancelButton: true,
              cancelButtonText: "OK",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Back to Mode of Payment List",
            }).then((result) => {
              if (result.value) {
                this.goToList();
              }
            });
          })
          .catch((err) => {
            // console.log(err);
            Swal.fire(
              "Update Failed!",
              err.message? err.message : `${mopObj.productName} was not updated.`,
              "error"
            );
          });
      }
      
    },
    goToList(){
      this.redirectForm = false;
      this.$router.push({name:"ModeOfPayment", hash: '#module'});
    },
    clearForm(){
      this.mopModuleItem = {
        "mopId": null,
        "module": null,
        "rateType":null,
        "minAmountRequired": null,
        "mdrPercentage": null,
        "rebatePercentage": null,
        "status": "a",
        "successRedirect": null,
        "failRedirect": null
      };
      this.$refs.formReset.click();
    },
    leaveform(next){
      var temp = {
        name: this.mopModuleItem.name,
        displayName: this.mopModuleItem.displayName,
        code: this.mopModuleItem.code,
        paymongoEndpointType: this.mopModuleItem.paymongoEndpointType,
        logo: this.mopModuleItem.logo,
        status: this.mopModuleItem.status,
        fullLogoUrl: this.mopModuleItem.fullLogoUrl
      }

      if(JSON.stringify(temp) == JSON.stringify(this.formExitChecker)){
        next();
        return;
      }
      Swal.fire({
          title: 'Are you sure?',
          text: "you want to leave this page?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '##804997',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
      }).then((result) => {
          if (result.isConfirmed) {
              next();
          }else{
              return;
          }
      })
    },

    async validateSchedule() {
      if (this.inactiveSchedule.status) {
        this.scheduleValidation.error = null;
  
        const startDate = moment(this.inactiveSchedule.start);
        const endDate = moment(this.inactiveSchedule.end);

        if (this.inactiveSchedule.start && !this.inactiveSchedule.end) {
          console.log("1")
          this.scheduleValidation.isEndDateValid = false;
          this.scheduleValidation.error = 'End date must not be empty';
        }

        if (!this.inactiveSchedule.start && this.inactiveSchedule.end) {
          console.log("2")
          this.scheduleValidation.isStartDateValid = false;
          this.scheduleValidation.error = 'Start date must not be empty';
        }
  
        if ((this.inactiveSchedule.start && this.inactiveSchedule.end) && !endDate.isAfter(startDate)) {
          console.log("3")
          this.scheduleValidation.isEndDateValid = false;
          this.scheduleValidation.error = 'End date must be after start date';
        }
      } else {
        this.scheduleValidation.isStartDateValid = true;
        this.scheduleValidation.isEndDateValid = true;
      }
    },
    resetSchedule() {
      this.scheduleValidation = {
        isStartDateValid: true,
        isEndDateValid: true,
        error: null
      }
    }
  },
  async mounted(){
    this.listMop().then(() => {
      this.mopList = _.cloneDeep(this.mops)
    });

    this.changeTitle({title: 'Add Module Mode'});
    this.listMop();
    this.getModules();

    if(this.mode == 'edit' && this.methodId){
      await this.getMopModule(this.methodId)
        .then((mopModuleItem) => {
          this.mopModuleItem = Object.assign({}, mopModuleItem);
          this.currentMopModuleItem = _.cloneDeep(this.mopModuleItem);
          this.inactiveSchedule.status = this.mopModuleItem.inactive_sched_status ? true: false;
          this.inactiveSchedule.start = this.mopModuleItem.inactive_sched_start
          this.inactiveSchedule.end = this.mopModuleItem.inactive_sched_end
        });
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'Modes of Payment')
    .then((access) => this.modesOfPaymentModule.access = access);

  }
}
</script>

<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.mop-form {
  max-width: 600px;
}

.form-control.invalid {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.invalid ~ .invalid-feedback {
  display: block;
}

.change-preview {
  position: fixed;
  left: 50%;
  top: 18%;
  transform: translateX(-50%);
  z-index: 2050;
  background: transparent;
  padding: 0;
  pointer-events: none;
}

  .change-preview__inner {
  background: #0f1112 !important;
  border-radius: 12px;
  padding: 22px 26px;
  width: 720px;
  max-width: 94vw;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.04);
  pointer-events: auto;
}



.table-change thead th {
  background: #0f1112 !important;
  color: #ffffff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.913);
  font-weight: 700;
  font-size: 14px;
  padding: 10px 12px;
  text-align: left;
}

.table-change td {
  background: #0f1112 !important;
  color: #e6e6e6 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.654);
  padding: 11px 12px;
  font-size: 13px;
  line-height: 1.4;
}
.table-change tbody tr:last-child td {
  border-bottom: none;
}

.table-change tbody tr:hover {
  background: rgba(255, 255, 255, 0.02);
}

.change-preview__inner .table-change td {
  padding: 8px 18px;
  vertical-align: top;
}
.change-preview__inner .table-change thead th {
  padding: 12px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.12);
}
.change-preview__inner .before-line strong,
.change-preview__inner .after-line strong {
  color: #e6e6e6;
  /* font-weight: 600; */
}

.btn-close {
  background: transparent;
  border: 0;
  color: #ffffff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.12s;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close:hover { opacity: 1; }

::v-deep .modal-content {
  border-radius: 12px;
  padding: 22px 24px;
}

/* Responsive tweaks specific to the change log modal */
.change-log-modal .modal-dialog {
  max-width: 900px;
  width: 100%;
}

@media (max-width: 992px) {
  .change-log-modal .modal-dialog { max-width: 720px; }
}

@media (max-width: 768px) {
  .change-log-modal .modal-dialog { max-width: 95vw; margin: 0.5rem; }
  .change-log-modal .modal-content { padding: 14px; }
}

@media (max-width: 576px) {
  /* Stack the controls vertically and make them full width */
  .change-log-modal .row.align-items-start.g-0 > .col-sm-2,
  .change-log-modal .row.align-items-start.g-0 > .col-sm-3,
  .change-log-modal .row.align-items-start.g-0 > .col-sm-1 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  /* Make form groups left-aligned on small screens */
  .change-log-modal .b-form-group.text-end {
    text-align: left !important;
  }

  /* Remove left margins added for desktop spacing */
  .change-log-modal .ms-3 { margin-left: 0 !important; }

  /* Buttons group: keep inline, right-aligned, and wrap when needed */
  .change-log-modal .buttons-group {
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .change-log-modal .buttons-group .btn {
    min-width: 110px;
  }
}

.logs-controls {
  gap: 8px;
  flex-wrap: wrap;
}

.logs-controls .form-control,
.logs-controls .form-select {
  height: 40px;
  border-radius: 8px;
}

.view-link {
  color: #e935a1;
  font-weight: 600;
  text-decoration: underline !important;
}
.view-link:hover {
  text-decoration: underline;
}

/* table header and rows */
::v-deep .table thead th {
  font-weight: 600;
  color: #111827;
}
::v-deep .table tbody td {
  color: #111827;
  vertical-align: middle;
}

/* make pagination dots purple */
::v-deep .pagination-rounded .page-item.active .page-link {
  background: #804997;
  border-color: #804997;
}

::v-deep .btn-outline-primary:hover,
::v-deep .btn-export-logs:hover {
  background: #e935a1;
  border-color: #e935a1;
  color: #ffffff;
}

::v-deep .modal-footer {
  border-top: none !important;
  padding-top: 0.2rem !important;
  padding-bottom: 0.2rem !important;
}
</style>